import { HTMLAttributes } from 'react'
import { Box } from '@mui/material'

const variantSpacing: Record<string, number> = {
  '3xs': 1,
  xxs: 2,
  xs: 4,
  sm: 6,
  md: 8,
  lg: 9,
  xl: 10,
  '2xl': 11,
  standard: 12
}

export type SpacerProps = HTMLAttributes<HTMLDivElement> & {
  size?: keyof typeof variantSpacing
  sx?: Record<string, any>
  is_first?: boolean
}

const Spacer = ({ size = 'md', sx, is_first, ...props }: SpacerProps) => {
  return (
    <Box
      component="hr"
      sx={(theme) => ({
        border: 0,
        background: 'transparent',
        display: 'block',
        width: '100%',
        margin: 0,
        padding: 0,
        height: theme.spacing(variantSpacing[size] ?? variantSpacing.md),
        ...sx
      })}
      {...props}
    />
  )
}

export default Spacer
